import React from "react";
import "../TeamAvailability.css";
import "../../eventRoster/MemberRoster.css";
import { getJSON } from "../../misc/qf.js";

class TeamRosterContainer extends React.Component {
  state = {
    members: [],
    isLoading: true,
  };
  user_children = new Set(this.props.user_children);

  componentDidMount() {
    getJSON(this.props.sourceUrl).then((data) => {
      let error = ''
      if (data.all_occurrences.length === 0){
        error = "Event is no longer available."
      }
      this.setState({
        error: error,
        members: data.team_members,
        isLoading: false,
      });
    })
  }

  render() {
    if (this.state.isLoading && this.state.members.length === 0) {
      return (
        <div className="container text-center">
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading &hellip;
        </div>
      );
    }

    const athletes = [];
    const coaches = [];
    this.state.members.forEach((member) => {
      if (member.role === "player" || member.role === "captain") {
        athletes.push(member);
      } else if (member.role === "coach") {
        coaches.push(member);
      } else {
      }
    });
    return (
      <TeamAvailability
        error = {this.state.error }
        user_children={this.user_children}
        admin={this.props.admin}
        loggedInUser={this.props.loggedInUser}
        athletes={athletes}
        coaches={coaches}
      />
    );
  }
}

export default TeamRosterContainer;

class TeamAvailability extends React.Component {
  render() {
    let athletesSection = null;
    if (this.props.athletes) {
      athletesSection = (
        <>
        {this.props.error && <div className="mt-3 alert alert-danger d-flex align-items-center fs-5" role="alert">
            <i className="fa-sharp fa-regular fa-circle-exclamation"></i> <span className="ms-2">
            {this.props.error}
          </span>
        </div>}
        <section className="SectionContainer shadow-sm mt-4">
          <header className="SectionHeader d-flex justify-content-between align-items-center">
            <h1 className="text-uppercase">
              Players:
              <span className="ms-1">
                ( {this.props.athletes.length} / {this.props.athletes.length} )
              </span>
            </h1>
          </header>
          <div className="SectionBody position-relative">
            <div className="container u-borderBottom">
              {this.props.athletes.length === 0 && (
                <p className="text-center fst-italic m-0 p-4">
                  There are no Players
                </p>
              )}
              <ul
                className={`row p-0 ${
                  this.props.athletes.length > 0 && "pb-2"
                } m-0 list-unstyled`}
              >
                {this.props.athletes.map((member) => {
                  return (
                    <TeamAvailabilityMember
                      key={member.id}
                      member={member}
                      admin={this.props.admin}
                      user_children={this.props.user_children}
                      loggedInUser={this.props.loggedInUser}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </section>
        </>
      );
    }
    let coachesSection = null;
    if (this.props.coaches) {
      coachesSection = (
        <section className="SectionContainer shadow-sm">
          <header className="SectionHeader d-flex justify-content-between align-items-center">
            <h1 className="text-uppercase">
              coaches:
              <span className="ms-1">
                ( {this.props.coaches.length} / {this.props.coaches.length} )
              </span>
            </h1>
          </header>
          <div className="SectionBody position-relative">
            <div className="container u-borderBottom">
              {this.props.coaches.length === 0 && (
                <p className="text-center fst-italic m-0 p-4">
                  There are no Coaches
                </p>
              )}
              <ul
                className={`row p-0 ${
                  this.props.coaches.length > 0 && "pb-2"
                } m-0 list-unstyled`}
              >
                {this.props.coaches.map((member) => {
                  return (
                    <TeamAvailabilityMember
                      key={member.id}
                      member={member}
                      admin={this.props.admin}
                      user_children={this.props.user_children}
                      loggedInUser={this.props.loggedInUser}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </section>
      );
    }
    return (
      <>
        {athletesSection}
        {coachesSection}
      </>
    );
  }
}

class TeamAvailabilityMember extends React.Component {
  render() {
    const { admin, user_children, loggedInUser, member } = this.props;
    return (
      <MemberCard
        member={member}
        canEdit={
          admin || user_children.size > 0 && member && user_children.has(member.id) || loggedInUser.id === member.id
        }
      />
    );
  }
}

const MemberCard = ({ member, canEdit }) => {
  const { profile_picture, user, edit } = member._links;
  return (
    <li className="col-12 col-md-6 col-lg-4 mt-3">
      <div className="MemberCard pe-md-2">
        {user ? (
          <>
            <div className="Post-info d-flex mb-2">
              <a className="me-2" href={user ? user.href : ""}>
                <img
                  className="MVP-img event-profile"
                  src={profile_picture.href}
                  alt=""
                />
              </a>
              <div className="text-start flex-grow-1 Member-Info">
                <a
                  className="text-start Post-by pe-3 u-teamColorTxt"
                  href={user ? user.href : ""}
                >
                  {member.last_name}, {member.first_name}
                </a>
                <p className="GradYear">
                  {member.grad_year
                    ? `Class of ${member.grad_year}`
                    : `(${member.role})`}
                </p>
              </div>
              <a
                href={edit.href}
                className={`editMember ${canEdit ? "" : "d-none"}`}
              >
                <small>
                  <i className="fa-solid fa-ellipsis"></i>
                </small>
              </a>
            </div>
          </>
        ) : (
          <>
            <div className="Post-info d-flex mb-2">
              <img
                className="MVP-img event-profile me-2"
                src={profile_picture.href}
                alt=""
              />
              <div className="text-start flex-grow-1 Member-Info">
                <span className="text-start Post-by pe-3">
                  {member.last_name}, {member.first_name}
                </span>
                <p className="GradYear">
                  {member.grad_year
                    ? `Class of ${member.grad_year}`
                    : `(${member.role})`}
                </p>
              </div>
            </div>
            <a
              href={edit.href}
              className={`editMember ${canEdit ? "" : "d-none"}`}
            >
              <small>
                <i className="fa-solid fa-ellipsis"></i>
              </small>
            </a>
          </>
        )}
      </div>
    </li>
  );
};
